import React from 'react'
import PropTypes from 'prop-types'

import TitlePage from 'app/componentV4/TitlePage'

function PanelPages(props) {
  const { isEmptyState, emptyState, title, rightContent, children } = props
  return (
    <div className="p-24 h-full md:overflow-hidden overflow-auto">
      {isEmptyState ? (
        emptyState
      ) : (
        <>
          <div
            className="w-full space-y-5 md:space-y-0 md:flex justify-between space-y-3"
            // style={{ height: '42px' }}
          >
            <div className="flex items-center">
              <TitlePage label={title} />
            </div>
            {rightContent}
          </div>
          <div className="my-5" style={{ height: '-webkit-fill-available' }}>
            {children}
          </div>
        </>
      )}
    </div>
  )
}

PanelPages.propTypes = {
  isEmptyState: PropTypes.bool,
  emptyState: PropTypes.node,
  title: PropTypes.string,
  rightContent: PropTypes.node,
  children: PropTypes.node,
}

export default PanelPages
